import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { IssueCreateIssuesTasksDirectiveController } from './issue-create-issues-tasks.directive.controller'
import { IUserSession } from '../../../helpers/user-session'
import { ReferenceTypeService, REFERENCE_TYPE_SERVICE_NAME } from '../../../services/reference-type'
import { OperatorSecurityService, OPERATOR_SECURITY_SERVICE_NAME } from '../../../services/operator'

//#region Asset Imports

import './issue-create-issues-tasks.scss'
import * as TEMPLATE from './issue-create-issues-tasks.tpl.html'

//#endregion

export class IssueCreateIssuesTasksDirective implements ng.IDirective {
	restrict = 'E'
	scope = {
		id: '=',
	}

	controller = [
		'$scope',
		'$q',
		'$element',
		'$timeout',
		'api',
		'logger',
		'localDictionary',
		'userSession',
		REFERENCE_TYPE_SERVICE_NAME,
		OPERATOR_SECURITY_SERVICE_NAME,
		(
			$scope,
			$q: ng.IQService,
			$element: JQuery,
			$timeout: ng.ITimeoutService,
			api: Api,
			logger: LoggerService,
			localDictionary: LocalDictionaryFactory,
			userSession: IUserSession,
			referenceTypeService: ReferenceTypeService,
			operatorSecurityService: OperatorSecurityService
		) => {
			return new IssueCreateIssuesTasksDirectiveController($scope, $q, $element, $timeout, api, logger, localDictionary, userSession, referenceTypeService, operatorSecurityService)
		},
	]

	template = TEMPLATE
}
